import moment from 'moment-timezone'
import langTranslation from '../../../langTranslation.json'

const translationErrorLog = (debug, msg) => {
    if(debug) {
        console.error('TRANSLATION TIME ERROR: ' + msg)
    }
}

const getTranslationTime = (id, timezone, currentLang, timeString, debug, before="", after="") => {
    const translationTime = langTranslation.translationTime
    let transString

    if(timezone && translationTime[id] && currentLang && translationTime[id].format[currentLang]) {
        const momentDate = moment.tz(timeString, timezone)

        transString = momentDate.format(translationTime[id].format[currentLang])
    } else {

        translationErrorLog(debug, `No time translation for id ${id}`)
    }

    if(before) {
        transString = before + transString
    }

    if(after) {
        transString = transString + after
    }

    return transString
}

export default getTranslationTime

